module.exports = __webpack_public_path__ + "static/media/brighton.eb299d67.png";